
import { Actions } from "../Actions/Actions";

const initialState = {
    isApiFetched: false,
    contactData: {},
    cityData: {},

};


export default function commonReducer(state = initialState, action) {
    switch (action.type) {
        case Actions.CONTACT_DATA:
            return {
                ...state,
                isApiFetched: true,
                contactData: action.data.contactData,

            };

            case Actions.FETCH_CITIES:
            return {
                ...state,
                isApiFetched: true,
                cityData: action.data.cityData,

            };


        default:
            return {
                ...state,
            }
    }
}
